export default "__VITE_ASSET__586ab2fe__"